import {
  keepPreviousData,
  type QueryObserverOptions,
  useQuery,
} from '@tanstack/react-query';
import ms from 'ms';
import api from '#/api';
import type { RequestOpts } from '#/api/api-types';
import queryClient from '#/api/queryClient';

export const MIN_SEARCH_QUERY_LENGTH = 3;

const method = api.getSearch;
export type Response = Awaited<ReturnType<typeof api.getSearch>>;
export type GetSearchResultsQueryParams = Parameters<typeof api.getSearch>[0];

function getSearchResultsQuery(
  params: GetSearchResultsQueryParams,
  opts: RequestOpts = {},
) {
  const queryKey = ['search', params];
  return {
    queryKey,
    queryFn: ({ signal }) => method({ ...params }, { ...opts, signal }),
    initialDataUpdatedAt: queryClient.getQueryState(queryKey)?.dataUpdatedAt,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    placeholderData:
      params?.query && params.query.length >= MIN_SEARCH_QUERY_LENGTH
        ? keepPreviousData
        : undefined,
    staleTime: ms('15m'),
    gcTime: ms('30s'),
  };
}

export function useSearchResults(
  queryParams: GetSearchResultsQueryParams,
  options?: Omit<QueryObserverOptions<Response>, 'queryKey'>,
) {
  const query = getSearchResultsQuery(queryParams);
  return useQuery({
    ...query,
    ...options,
  });
}
